import React, { useState, useEffect } from 'react';
import { Row, Col, Spin, Button } from 'antd';
import map from 'lodash/map';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import useFetch from 'utils/fetch/useFetch';
import { WAREHOUSES } from 'api';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import StorageCard from './components/StorageCard';
import Modal from '../../../src/components/Modal/index';
import StorageForm from './components/StorageForm';
import AddStorageButton from './components/ButtonStyled';
import Search from './components/Seacrh';
import { ReactComponent as Plus } from '../../images/plus_icon.svg';

function Storage() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const total = useSelector((state) =>
    get(state, `fetch.warehouses.total`, null),
  );
  const limit = useSelector((state) =>
    get(state, `fetch.warehouses.limit`, null),
  );
  const [stateSearch, setStateSearch] = useState(false);
  const [pushItems, setPushItems] = useState(null);
  const [generalTotal, setGeneralTotal] = useState(null);
  const {
    data,
    loading,
    postData,
    getData,
    deleteData,
    updateData,
    loadMore,
  } = useFetch(WAREHOUSES, {
    uniqId: 'warehouses',
    autoFetch: true,
    initialOptions: { limit: 10 },
  });

  const handledeleteData = (id) => {
    deleteData(
      { id },
      {
        sync: false,
        getSyncData: {
          fetchFunc: getData,
          params: {
            limit,
          },
        },
      },
    );
  };

  const handleCreate = (data) => {
    delete data.lintToInstruction;
    postData({
      ...data,
    });
  };

  const handleEdit = async (data) => {
    delete data.lintToInstruction;
    updateData({ ...data });
  };

  const loadMoreItems = () => {
    if (stateSearch) {
      getData({
        search: stateSearch,
        limit: pushItems,
      });
      setPushItems(pushItems + 5);
    } else {
      loadMore(pushItems);
      setPushItems(pushItems + 5);
    }
  };

  useEffect(() => {
    if (total && !generalTotal) {
      setGeneralTotal(total);
    }
  }, [total]);

  useEffect(() => {
    if (data && !pushItems) setPushItems(data.length + 10);
  }, [data]);

  return (
    <>
      <div className="mb-30">
        <Search
          limit={limit}
          setStateSearch={setStateSearch}
          total={total}
          generalTotal={generalTotal}
          search={getData}
        />
      </div>
      <Spin spinning={loading}>
        <div className="my-6">
          <Row gutter={[16, 16]}>
            <Col className="flex items-center" span={6}>
              <AddStorageButton
                onClick={() => {
                  setOpen(!open);
                }}
              >
                <Plus />
              </AddStorageButton>
            </Col>
            {map(data, (item, index) => {
              return (
                <Col span={6} key={index}>
                  <StorageCard
                    key={index}
                    data={item}
                    deleteData={handledeleteData}
                    box={item.boxes}
                    name={item.name}
                    edit={handleEdit}
                  />
                </Col>
              );
            })}
          </Row>
          <Modal width={470} setVisible={setOpen} visible={open}>
            <StorageForm
              setVisible={setOpen}
              visible={open}
              create={handleCreate}
              modal
            />
          </Modal>
        </div>
        {data ? (
          total !== data.length ? (
            <div className="flex w-full mt-20 mb-20 justify-center items-center">
              <Button
                type="primary"
                onClick={() => {
                  loadMoreItems();
                }}
              >
                {t('loadMore')}
              </Button>
            </div>
          ) : null
        ) : null}
      </Spin>
    </>
  );
}

Storage.propTypes = {};

export default Storage;
